// src/config/apiConfig.js

/* ── Base URL ───────────────────────────────────────────────────
   Change this one line to switch between environments.
   ─────────────────────────────────────────────────────────────── */
export const BASE_URL = 'https://dgdoctor.versatileitsolution.com';
// export const BASE_URL = 'http://localhost:5000';


/* ── Default Headers ────────────────────────────────────────────
   Shared headers sent with every request.
   Authorization token is injected automatically if present.
   ─────────────────────────────────────────────────────────────── */
export const getHeaders = () => {
  const headers = {
    'Content-Type': 'application/json',
    'Accept':       'application/json',
  };

  // Attach JWT token from localStorage if available
  const token = localStorage.getItem('dg_token');
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
};

/* ── API Endpoints ──────────────────────────────────────────────
   All endpoint paths in one place.
   ─────────────────────────────────────────────────────────────── */
export const API_ENDPOINTS = {
  // Auth
  REGISTER:        `${BASE_URL}/api/register/createuser`,
  LOGIN:           `${BASE_URL}/api/register/login`,
  LOGOUT:          `${BASE_URL}/api/auth/logout`,
  FORGOT_PASSWORD: `${BASE_URL}/api/auth/forgot-password`,
  RESET_PASSWORD:  `${BASE_URL}/api/auth/reset-password`,
  DOCTOR_LOGIN:    `${BASE_URL}/api/doctors/getDoctorDetails`,

  // Appointments
  ALL_APPOINTMENTS:    `${BASE_URL}/api/admin/getTodaysAppointmentsforAdmin`,
  BOOK_APPOINTMENT:`${BASE_URL}/api/appointments/bookAppointment`,
  MY_APPOINTMENTS:`${BASE_URL}/api/appointments/getAppointmentByPatientID`,
  DOCTOR_APPOINTMENTS: `${BASE_URL}/api/appointments/getTodayDoctorAppointmentsbyDoctorID`,
  SAVE_PRESCRIPTION:   `${BASE_URL}/api/appointments/saveprescription`,

  GET_PRESCRIPTION:`${BASE_URL}/api/appointments/getprescription`,
  GET_LAB_RESULTS:`${BASE_URL}/api/appointments/getLabtests`,
  UPDATE_PAYMENT:`${BASE_URL}/api/appointments/updateAppointmentStatus`,
  QR_GENERATE:     `${BASE_URL}/api/appointments/UpdateQR`,
  QR_VERIFY:       `${BASE_URL}/api/appointments/getQRDetails`,
  DEPARTMENT_LIST:       `${BASE_URL}/api/deprtments/getDepartmentList`,
  // Doctors
  DOCTORS:         `${BASE_URL}/api/doctors`,
    LAB_MASTERS:     `${BASE_URL}/api/doctors/getlabmaster`,
  DOCTOR_LIST:     `${BASE_URL}/api/doctors/getdoctorlist`,
  ALL_DOCTOR_LIST: `${BASE_URL}/api/appointments/getAppointmentListByDoctorID`,
  DOCTOR_ADD:       `${BASE_URL}/api/doctors/addDoctor`,
  DOCTOR_UPDATE:  `${BASE_URL}/api/doctors/updateDoctor`,
  TIME_SLOT_LIST: `${BASE_URL}/api/doctors/TIME_SLOT_LIST`,
  TIME_SLOT_LIST_ForPatient: `${BASE_URL}/api/doctors/TIME_SLOT_LIST_ForPatient`,
  TIME_SLOT_ADD: `${BASE_URL}/api/doctors/TIME_SLOT_ADD`,
  TIME_SLOT_UPDATE_STATUS:`${BASE_URL}/api/doctors/TIME_SLOT_UPDATE_STATUS`,
  // Patients
  PATIENTS:        `${BASE_URL}/api/patients/getPatientList`,
UPLOAD_LAB_RESULTS:  `${BASE_URL}/api/lab/tests`,


  // QR


  // Lab
  UPLOAD_LAB_TESTS:       `${BASE_URL}/api/lab/tests`,

  // Pharmacy
  PHARMACY_DISPENSE:`${BASE_URL}/api/pharmacy/dispense`,
};

/* ── Reusable Request Helpers ───────────────────────────────────
   POST, GET, PUT, DELETE — all use getHeaders() automatically.
   ─────────────────────────────────────────────────────────────── */

// POST
export const postRequest = async (url, body) => {
  const response = await fetch(url, {
    method:  'POST',
    headers: getHeaders(),
    body:    JSON.stringify(body),
  });
  return response;
};

// GET
export const getRequest = async (url) => {
  const response = await fetch(url, {
    method:  'GET',
    headers: getHeaders(),
  });
  return response;
};

// PATCH
export const patchRequest = async (url, body) => {
  const response = await fetch(url, {
    method:  'PATCH',
    headers: getHeaders(),
    body:    JSON.stringify(body),
  });
  return response;
};

// PUT
export const putRequest = async (url, body) => {
  const response = await fetch(url, {
    method:  'PUT',
    headers: getHeaders(),
    body:    JSON.stringify(body),
  });
  return response;
};

// DELETE
export const deleteRequest = async (url) => {
  const response = await fetch(url, {
    method:  'DELETE',
    headers: getHeaders(),
  });
  return response;
};